import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import {
  TextInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { avobboxtext } from "variables/MBM/avobbox";
import { serverTypeBoxCreationData, serverTypeBoxModificationData } from "variables/MBM/lists/avobbox";
import { postMBMAVOBBox, putMBMAVOBBox, getMBMIotConnectors } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";
import { getMBMIotConnector } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  submitButtonEdit: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabledEdit: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function AVOBBoxDialog(props) {
  const { closeModal, refetch, currentBox } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [name, setName] = useState(currentBox?.name || "");
  const [description, setDescription] = useState(currentBox?.description || "");
  const [location, setLocation] = useState(currentBox?.chirpstackparameters?.location || "");

  const [groups, setGroups] = useState(currentBox?.groupid ? "" + currentBox.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [address, setAddress] = useState(currentBox?.installationdetails?.address || {});
  const [validatedaddress, setValidatedaddress] = useState(currentBox?.installationdetails?.validatedaddress || {});
  const loaded = useRef(false);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (
      name.length > 0 &&
      groups.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, groups]);


  useEffect(() => {
    let newlocation = {};
    newlocation.altitude = 0;
    newlocation.accuracy = 0;
    newlocation.source = "UNKNOWN";
    newlocation.latitude = validatedaddress?.geometry?.location?.lat || 0;
    newlocation.longitude = validatedaddress?.geometry?.location?.lng || 0;
    setLocation(newlocation);
    console.log(newlocation);
  }, [validatedaddress]);



  const handleSubmit = async (event) => {
    if (currentBox)
      updateAVOBbox(event);
    else
      createAvobbox(event);
  };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const createAvobbox = async (event) => {
    await axios
      .post(
        postMBMAVOBBox(),
        {
          groups,
          name,
          description,
          location,
          validatedaddress,
          address,
          type: "3"
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Box créée");
        } else setNotification("error", res.data.message);
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error.response);
        setNotification("error", "Une erreur est survenue : " + error.response?.data?.message);
      });
  };

  const updateAVOBbox = async (event) => {

    await axios
      .put(
        putMBMAVOBBox(currentBox.id,"update"),
        {
          groups,
          name,
          description,
          location,
          validatedaddress,
          address,
          type: "3"
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Box modifiée");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>

            < div >
              <TextInput
                isRequired
                inputTitle={avobboxtext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={avobboxtext.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <LocalizationAutocomplete
                isRequired
                specialWidth={"97%"}
                inputTitle={avobboxtext.address}
                value={address}
                setValue={setAddress}
                inputValue={inputValue}
                setInputValue={setInputValue}
                options={options}
                setOptions={setOptions}
                setValidatedAddress={setValidatedaddress}
                validatedAddress={validatedaddress}
                loaded={loaded}
              />
            </div>

          </GridItem>

          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={chartIdGroup[0]}
                />
              </ImageList>
            </div>
          </GridItem>

        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            currentBox ?
              buttonDisabled
                ? classes.submitButtonDisabledEdit
                : classes.submitButtonEdit
              :
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default AVOBBoxDialog;
